'use client';
import React, { useMemo } from 'react';
import { SDKResponse } from '@commercetools/frontend-sdk';
import { PageResponse } from '@commercetools/frontend-sdk/lib/types/api/page';
import Toaster from 'components/commercetools-ui/atoms/toaster';
import MiniCartProvider from 'context/miniCart';
import TracingProvider from './tracing';

interface ProvidersProps {
  page: SDKResponse<PageResponse>;
}

export const Providers = ({ page, children }: React.PropsWithChildren<ProvidersProps>) => {
  // Memoize children to prevent unnecessary re-renders when page reference changes
  // but actual page data hasn't changed
  const memoizedChildren = useMemo(() => children, [children]);

  return (
    <TracingProvider page={page}>
      <MiniCartProvider>{memoizedChildren}</MiniCartProvider>
      <Toaster />
    </TracingProvider>
  );
};